import { createAction, props } from '@ngrx/store';

import { CustomPDFReportTab } from '../../interfaces/custom-pdf-report-tab.interface';

export const setTabs = createAction('[Custom PDF Report Builder] Set Tabs', props<{ tabs: CustomPDFReportTab[] }>());

export const setIsEdited = createAction('[Custom PDF Report Builder] Set Is Edited', props<{ isEdited: boolean }>());
